import * as action_types from "../actionTypes";
import axios from "axios";
import { API_Prefix } from "../../component/config/config";
import { ClientId, SecretId } from "../../component/config/config";
let server_url = `${API_Prefix}/o/`;
let data = `grant_type=client_credentials&client_id=${ClientId}&client_secret=${SecretId}`;
let Token = null;
let newToken = null;
let storeAuthtoken = null;

// Read a param value from the current page URL (works whether it is in the query
// string or embedded in the path, e.g. /cyberisland/instruction/..&callbackUrl=..)
const getUrlParam = (name) => {
  const href = window.location.href;
  const idx = href.indexOf(`${name}=`);
  if (idx === -1) return null;
  let value = href.substring(idx + `${name}=`.length);
  const ampIdx = value.indexOf("&");
  if (ampIdx !== -1) value = value.substring(0, ampIdx);
  return value || null;
};

const getCallbackUrlFromUrl = () => getUrlParam("callbackUrl");

let storeCallbackUrl = getCallbackUrlFromUrl();
var storedomain;

export const Login = (data, accessToken) => {
  Token = accessToken;
  storedomain = data.email;
  const config_req = {
    headers: { Authorization: `Bearer ${accessToken}` },
  };

  return (dispatch) => {

     const payload = {
      enduserName: data.name,
      enduserEmail: data.email,
      token : data.token,
      phishrodGameId : "NDdBL213RDA1bzlUeGhTM3owZFhTdz09",
    }

    axios
      .post(API_Prefix + `/o/game/register-game-user`, payload, config_req
      )
      .then((response) => {

        dispatch({
          type: action_types.LOGIN,
          payload: response,
        });
      });
  };
};
// Admin Login ..................
export const Adminlogin = (data, accessToken) => {
  Token = accessToken;
  const config_req = {
    headers: { Authorization: `Bearer ${accessToken}` },
  };
  return (dispatch) => {

    const payload = {
      username: data.username,
      password: data.password,
      captchaToken: data.captchaToken,
    }
    axios
      .post(API_Prefix + `/o/game/admin-login`, payload,config_req
      )
      .then((response) => {
        storeAuthtoken = response.data.authToken;
        dispatch({
          type: action_types.ADMIN_LOGIN,
          payload: response,
        });
      });
  };
};
// Admin Competition Search-User ..........
export const AdminCompetitonSearch = (name,email, accessToken) => {
  Token = accessToken;
  const config_req = {
    headers: { Authorization: `Bearer ${accessToken}` },
  };
  return (dispatch) => {
    const payload = {
      authToken: storeAuthtoken,
      searchEmail: email,
      searchName: name,
    }
    axios
      .post(API_Prefix + `/o/game/search-user`, payload,config_req
      )
      .then((response) => {
        dispatch({
          type: action_types.SEARCH_USER,
          payload: response,
        });
      });
  };
};
// Admin Competition Search-User ..........
export const AdminCompetitonSearch2 = (name,email, accessToken) => {
  Token = accessToken;
  const config_req = {
    headers: { Authorization: `Bearer ${accessToken}` },
  };
  return (dispatch) => {
    const payload = {
      authToken: storeAuthtoken,
      searchEmail: email,
      searchName: name,
    }
    axios
      .post(API_Prefix + `/o/game/search-user`, payload,config_req
      )
      .then((response) => {
        dispatch({
          type: action_types.SEARCH_USER_PLAYER2,
          payload: response,
        });
      });
  };
};
// Admin-logout.............
export const AdminLogout = (accessToken) => {
  Token = accessToken;
  const config_req = {
    headers: { Authorization: `Bearer ${accessToken}` },
  };
  return (dispatch) => {
    // Clear admin login state immediately
    dispatch({
      type: action_types.CLEAR_ADMIN_LOGIN,
      payload: null,
    });

    // Then make the logout API call
    axios
    .get(
      `${API_Prefix}/o/game/logout?authToken=${storeAuthtoken}`,
      config_req
    )
      .then((response) => {
        dispatch({
          type: action_types.ADMIN_LOGOUT,
          payload: response,
        });
      })
      .catch((error) => {
        // Even if logout API fails, we've already cleared the state
        dispatch({
          type: action_types.ADMIN_LOGOUT,
          payload: { error: error.message },
        });
      });
  };
};
//Admin check-user-status...........
export const AdminCheckUserStatus = (prGameAttendeeId,accessToken) => {

  Token = accessToken;
  const config_req = {
    headers: { Authorization: `Bearer ${accessToken}` },
  };

  return (dispatch) => {

    if(storeAuthtoken!==null)
    {
    const payload = {
      authToken: storeAuthtoken,
      prGameAttendeeId: prGameAttendeeId
    }
    axios
      .post(API_Prefix + `/o/game/check-user-status`, payload,config_req
      )
      .then((response) => {
        dispatch({
          type: action_types.ADMIN_CHECK_STATUS,
          payload: response,
        });
      });
    }
  };
};
//Admin check-user-status...........
export const AdminCheckUserStatus2 = (prGameAttendeeId,accessToken) => {

  Token = accessToken;
  const config_req = {
    headers: { Authorization: `Bearer ${accessToken}` },
  };

  return (dispatch) => {

    if(storeAuthtoken!==null)
    {
    const payload = {
      authToken: storeAuthtoken,
      prGameAttendeeId: prGameAttendeeId
    }
    axios
      .post(API_Prefix + `/o/game/check-user-status`, payload,config_req
      )
      .then((response) => {
        dispatch({
          type: action_types.ADMIN_CHECK_STATUS_SECOND,
          payload: response,
        });
      });
    }
  };
};
// top-users-of-the-day.........
export const TopUsersOfDay = (email, accessToken, selectedFilter = "cyberisland") => {

  Token = accessToken;
  const config_req = {
    headers: { Authorization: `Bearer ${accessToken}` },
  };

  // Set phishrodGameId based on selected filter
  const phishrodGameId = selectedFilter === "cyberdrive"
    ? "REFwSzV0dmZncEVlYW5IUjc1Njh3dz09"
    : "NDdBL213RDA1bzlUeGhTM3owZFhTdz09";

  return (dispatch) => {
    const payload = {
      authToken: storeAuthtoken,
      domain: email,
      phishrodGameId: phishrodGameId,
    }
    axios
      .post(API_Prefix + `/o/game/fetch-top-users-of-the-day`, payload,config_req
      )
      .then((response) => {
        dispatch({
          type: action_types.TOP_USERS_OF_DAY,
          payload: response,
        });
      });
  };
};
export const UrlLogin = (urlParams,accessToken) => {
  const config_req = {
    headers: { Authorization: `Bearer ${accessToken}` },
  };
  return async (dispatch) => {
   const ss =  urlParams[0].split("=");
   const vv =  urlParams[1].split("=");

    // Parse the optional callbackUrl param (gameUserId=..&accountUserId=..&callbackUrl=..)
    let callbackUrl = null;
    if (urlParams[2]) {
      const sa = urlParams[2].split("=");
      callbackUrl = sa[1];
    }
    storeCallbackUrl = callbackUrl;

    const payload = {
    gameUserId: ss[1],
    accountUserId: vv[1],
    callbackUrl: callbackUrl
    };

    // If a callbackUrl exists, embed it with the campaign endpoint and post with no token
    if (callbackUrl) {
      await axios
        .post(`${callbackUrl}/o/game-guest/campaign-login-user`, payload)
        .then((response) => {
          const urlLoginResponse = response.data;
          dispatch({
            type: action_types.URL_PARAMS,
            payload: {payload,urlLoginResponse},
          });
        });
      return;
    }

    // Otherwise follow the normal flow with a token
    await axios
      .post(API_Prefix + `/o/game/login-user`, payload, config_req,
      )

      .then((response) => {
        const urlLoginResponse = response.data;
        dispatch({
          type: action_types.URL_PARAMS,
          payload: {payload,urlLoginResponse},
        });
      });
  };
};
export const PhishingModule = (score, phishingdetourcount) => {
  return (dispatch) => {
    const setPhishing = {
      score,
      phishingdetourcount,
    };
    dispatch({
      type: action_types.PHISHINGMODULE,
      payload: { setPhishing },
    });
  };
};
export const MalwareModule = (score, malwaredetourcount) => {
  return (dispatch) => {
    const setMalware = {
      score,
      malwaredetourcount,
    };
    dispatch({
      type: action_types.MALWAREMODULE,
      payload: { setMalware },
    });
  };
};
export const RansomewareModule = (score, ransomewaredetourcount) => {
  return (dispatch) => {
    const setRansomeware = {
      score,
      ransomewaredetourcount,
    };
    dispatch({
      type: action_types.RANSOMEWAREMODULE,
      payload: { setRansomeware },
    });
  };
};
export const InsiderThreatModule = (score, insiderthreatdetourcount) => {
  return (dispatch) => {
    const setInsider = {
      score,
      insiderthreatdetourcount,
    };
    dispatch({
      type: action_types.INSIDERTHREAT,
      payload: { setInsider },
    });
  };
};
export const SocialEngineeringModule = (
  score,
  socialengineeringdetourcount
) => {
  return (dispatch) => {
    const setSocial = {
      score,
      socialengineeringdetourcount,
    };
    dispatch({
      type: action_types.SOCIALENGINEERINGMODULE,
      payload: { setSocial },
    });
  };
};
export const DenialServiceModule = (score, denailservicedetourcount) => {
  return (dispatch) => {
    const setDenail = {
      score,
      denailservicedetourcount,
    };
    dispatch({
      type: action_types.DENIALSERVICE,
      payload: { setDenail },
    });
  };
};

// Commit a module's final answer tally (correct/wrong out of its questions)
// once, when the module is actually completed — not per answer — so a
// detour/retry of the same module doesn't get counted twice.
export const AddModuleAnswers = (correct, wrong) => ({
  type: action_types.ADD_MODULE_ANSWERS,
  payload: { correct, wrong },
});
export const AddGameTime = (seconds) => ({
  type: action_types.ADD_GAME_TIME,
  payload: seconds,
});
// Dispatched once, at the true start of a playthrough (the first module's
// mount), rather than on URL_PARAMS, which isn't guaranteed to fire exactly
// once per session (e.g. back-navigation to the splash screen).
export const ResetGameProgress = () => ({
  type: action_types.RESET_GAME_PROGRESS,
});

// Game Result API......................
export const GameResult = (result) => {
  return async (dispatch) => {
    // If a callbackUrl exists, post to the campaign endpoint with no token,
    // passing gameUserId, accountUserId and callbackUrl along with the result
    const callbackUrl = storeCallbackUrl || getCallbackUrlFromUrl();
    if (callbackUrl) {
      const campaignPayload = {
        phishrodGameId: result.phishrodGameId,
        moduleResults: result.moduleResults,
        gameUserId: getUrlParam("gameUserId"),
        accountUserId: getUrlParam("accountUserId"),
        callbackUrl: callbackUrl,
      };
      await axios
        .post(callbackUrl + `/o/game-guest/add-campaign-game-results`, campaignPayload)
        .then((response) => {
          dispatch({
            type: action_types.RESULT,
            payload: response,
          });
        });
      return;
    }

    // Otherwise follow the normal flow with a token
   await fetch(server_url + "oauth2/token", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: data,

    })
      .then((response) => response.json())
      .then((json) => {
        newToken = json.access_token;
      });
    const config_req = {
      headers: { Authorization: `Bearer ${newToken}` },
    };

    axios
      .post(API_Prefix + `/o/game/add-game-results`, result, config_req)
      .then((response) => {
        dispatch({
          type: action_types.RESULT,
          payload: response,
        });
      });
  };
};
